// extracted by mini-css-extract-plugin
export default {"notificationContainer":"style_notificationContainer__jv+Hq","container":"style_container__uFI3F","notificationAction":"style_notificationAction__iB0AW"};